<template>
  <div v-if="load == 1">
    <Dialog
      v-model:visible="visibles"
      modal
      header="Moniteurs"
      :style="{ width: '50vw' }"
      class="custom-dialog"
      :breakpoints="{ '1199px': '75vw', '575px': '90vw' }"
    >
      <div class="headerModal">
        <div v-if="!showEdit">
          <template v-if="this.$store.state.typeModalMono">
            <button class="btn btn-primary rounded-pill add" @click="showEditMono">
              +
            </button>
            <template v-if="showArchive">
              <button class="btn btn-danger" @click="archiveBtn">ARCHIVES</button>
            </template>
            <template v-else>
              <button class="btn btn-primary" @click="archiveBtn">ARCHIVES</button>
            </template>
          </template>
        </div>
        <div v-else>
          <button class="btn btn-primary" @click="goBackToList">Liste des monos</button>
        </div>

      </div>
      <div class="contentModal" v-if="!showEdit">
        <DataTable
          :value="this.moniteursTable"
          responsiveLayout="scroll"
          v-model:selection="moniteurEdits"
          selectionMode="single"
          @click="onSelected"
        >
          <Column field="code" header="">
            <template #body="{ data }">
              <template v-if="this.$store.state.typeModalMono">
                  <template v-if="data.choixPlanning == true">
                    <input
                      type="checkbox"
                      :id="data.idMono"
                      :name="data.id"
                      class="monoCheckag"
                      @change="moniteurChoice"
                      @change.stop
                      :value="data.idMono"
                      checked
                    />
                  </template>
                  <template v-else>
                    <input
                      type="checkbox"
                      :id="data.idMono"
                      :name="data.id"
                      :value="data.idMono"
                      class="monoCheckag"
                      @change="moniteurChoice"
                      @change.stop
                    />
                  </template>

              </template>
            </template>
          </Column>
          <Column field="boite" header="Boite"></Column>
          <Column field="fullname" header="Nom"></Column>
          <Column field="surnom" header="Surnom"></Column>
          <Column field="adresse.ville" header="Résidence"></Column>
          <Column field="telephone" header="Tél"></Column>
          <Column field="lieux" header="Lieux RDV">
            <template #body="{ data }">

              <span :title="data.lieuMonoString">{{ data.lieuMonoString.substring(0,30) }}...</span>

            </template>
          </Column>
          <Column field="quantity" header="Archive" v-if="this.$store.state.typeModalMono">
            <template #body="{ data }">
              <template v-if="showArchive">
                <input
                  type="checkbox"
                  :id="data.idMono"
                  :name="data.idMono"
                  @change="archiveMono"
                  checked
                />
              </template>
              <template v-else>
                <input
                  type="checkbox"
                  :id="data.idMono"
                  :name="data.idMono"
                  @change="archiveMono"
                />
              </template>
            </template>
          </Column>
        </DataTable>
      </div>
      <EditMonoModal v-else visible="true" @cancelModal="cancelModal" :moniteurEdits="moniteurEdits" @showEditMonoReset="showEditMonoReset" @getAllMoniteurs="getAllMoniteurs" />
    </Dialog>
  </div>
</template>

<script>
import EditMonoModal from "@/components/agence/planning/modals/EditMonoModal.vue";

export default {
  props: ["visible", "moniteurs", "monoChecked", "choixMonoSaves", "getLesMoniteurs"],

  components: {
    EditMonoModal,
  },

  watch: {
    visibles: function () {
      if (this.visibles == false) {
        this.$store.commit("setShowMonoPopupConduite", false);
        if (this.hasChanges) {
          window.location.reload();
        }
      }
    },
  },

  data() {
    return {
      visibles: false,
      showArchive: false,
      moniteursTable: [],
      showEdit: false,
      moniteurEdits: null,
      choixSaveMono: [],
      load : 0,
      hasChanges: false,
    };
  },

  mounted() {
    this.visibles = this.visible;
    this.moniteursTable = this.$store.state.moniteursPlanningAgence;
    
    this.choixMonoSave();
  },

  methods: {

  onDialogHide() {
    console.log("La modale a été fermée (croix, clic extérieur ou ESC).")
  },

    cancelModal(){
      this.visibles = false;
    },

    getAllMoniteurs(){
      this.$emit("getLesMoniteurs");
    },

    goBackToList(){
      this.showEdit = false;
    },

    choixMonoSave() {
      window.api
        .get("/agence/choix/" + this.$store.state.user.id, {
          headers: {
            Authorization: "Bearer " + this.$store.state.token,
          },
        })
        .then((response) => {
          if (response.data.choix.length != 0) {
            this.choixSaveMono = response.data.choix[0];
            let monoinput = document.querySelectorAll(".monoCheckag");
            monoinput.forEach((mono) => {
              this.choixSaveMono.choix.forEach((choix) => {
                if (parseInt(mono.attributes[2].value) == choix.id) {
                  mono.checked = true;
                }
              });
            });
          }
          this.load++;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    moniteurChoice() {
      this.hasChanges = true;
      let checkboxMoniteur = document.querySelectorAll(".monoCheckag");
      let moniteurchoix = [];

      checkboxMoniteur.forEach((checkbox) => {
        if (checkbox.checked) {
          let res = this.$store.state.moniteursPlanningAgence.find((moniteur) => {
            return moniteur.idMono == checkbox.value;
          });
          this.$emit("moniteurChoicePlanning", res, true);
          moniteurchoix.push({ title: res.surnom, id: res.idMono });
        }else{
          let res = this.$store.state.moniteursPlanningAgence.find((moniteur) => {
            return moniteur.idMono == checkbox.value;
          });
          this.$emit("moniteurChoicePlanning", res, false);
        }
      });
      //this.calendarOptions.resources = moniteurchoix;
      if (this.$store.state.choixSaveMono.length == 0) {
        window.api
          .post(
            "/choix_dispo_eleves",
            {
              choix: moniteurchoix,
              eleve: "api/utilisateurs/" + this.$store.state.user.id,
            },
            {
              headers: {
                Authorization: "Bearer " + this.$store.state.token,
              },
            }
          )
          .then(() => {
            this.$emit("choixMonoSaves");
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        window.api
          .put(
            "/choix_dispo_eleves/" + this.choixSaveMono.id,
            {
              choix: moniteurchoix,
              eleve: "api/utilisateurs/" + this.$store.state.user.id,
            },
            {
              headers: {
                Authorization: "Bearer " + this.$store.state.token,
              },
            }
          )
          .then(() => {
            this.$emit("choixMonoSaves");
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },

    onSelected() {
      if (this.moniteurEdits != null && this.$store.state.typeModalMono == true) {
        this.$store.commit("setRdvBoite", null);
        this.showEdit = true;
      }
    },

    showEditMono() {
      this.moniteurEdits = null;
      if (this.showEdit) {
        this.showEdit = false;
      } else {
        this.showEdit = true;
      }
    },

    showEditMonoReset() {
        this.moniteurEdits = null;
        this.showEdit = false;
    },

    archiveBtn() {
      if (this.showArchive) {
        this.showArchive = false;
        this.moniteursTable = this.$store.state.moniteursPlanningAgence;
      } else {
        this.showArchive = true;
        this.moniteursTable = this.$store.state.moniteursPlanningAgenceArchive;
      }
    },

    archiveMono(e) {
      let checked = false;
      if (e.target.checked) {
        checked = true;
      }
      let moniteur = null;
      let id = e.target.id;
      if (this.showArchive) {
        moniteur = this.$store.state.moniteursPlanningAgenceArchive.find(
          (e) => e.idMono == id
        );
      } else {
        moniteur = this.$store.state.moniteursPlanningAgence.find(
          (e) => e.idMono == id
        );
      }

      if (checked) {
        let planningCheckbox = document.querySelector(
          ".monoCheckag[value='" + moniteur.idMono + "']"
        );
        if (planningCheckbox && planningCheckbox.checked) {
          planningCheckbox.checked = false;
          moniteur.choixPlanning = false;
          moniteur.checked = false;
          this.moniteurChoice();
        }
      }

      if (checked) {
        window.api
          .patch(
            "/utilisateur/" + moniteur.id,
            {
              active: false,
            },
            {
              headers: {
                Authorization: "Bearer " + this.$store.state.token,
                "Content-Type": "application/merge-patch+json",
              },
            }
          )
          .then(() => {
            let moniteursFilter =
              this.$store.state.moniteursPlanningAgence.filter(
                (e) => e.id != moniteur.id
              );
            this.$store.commit("setMoniteursPlanningAgence", moniteursFilter);
            let moniteursArchive =
              this.$store.state.moniteursPlanningAgenceArchive;
            moniteursArchive.push(moniteur);
            this.$store.commit(
              "setMoniteursPlanningAgenceArchive",
              moniteursArchive
            );
            this.moniteursTable = this.moniteursTable.filter(
              (mono) => mono.id != moniteur.id
            );
            e.target.checked = false;
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        window.api
          .patch(
            "/utilisateur/" + moniteur.id,
            {
              active: true,
            },
            {
              headers: {
                Authorization: "Bearer " + this.$store.state.token,
                "Content-Type": "application/merge-patch+json",
              },
            }
          )
          .then(() => {
            e.target.checked = false;
            let moniteursFilter =
              this.$store.state.moniteursPlanningAgenceArchive.filter(
                (e) => e.id != moniteur.id
              );
            this.$store.commit(
              "setMoniteursPlanningAgenceArchive",
              moniteursFilter
            );
            let moniteurs = this.$store.state.moniteursPlanningAgence;
            moniteurs.push(moniteur);
            this.$store.commit("setMoniteursPlanningAgence", moniteurs);
            this.moniteursTable = this.moniteursTable.filter(
              (mono) => mono.id != moniteur.id
            );
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },

    met(e) {
      let checked = false;
      if (e.target.checked) {
        checked = true;
      }
      let id = e.target.id;
      let moniteur = this.$store.state.moniteursPlanningAgence.find(
        (e) => e.idMono == id
      );
      this.$emit("moniteurChoicePlanning", moniteur, checked);
    },
  },
};
</script>

<style scoped>

div.headerModal{
  margin-bottom: 1rem;
}

div.headerModal button.add {
  margin-right: 5em;
}

div.listLieux{
  border: 1px solid rgb(201, 201, 201);
  border-radius: 2%;
  overflow: scroll;
  height: 25px;
}

div.listLieux p{
  border-bottom: solid 1px rgb(201, 201, 201);
}

.custom-dialog .p-dialog-content {
  height: 99vh !important;
}

/* DATATABLE STYLE */

/* Table wrapper */
:deep(.p-datatable) {
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  overflow: hidden;
  font-size: 14px;
}

/* Header */
:deep(.p-datatable .p-datatable-thead > tr > th) {
  background: #ffffff;
  color: #9ca3af;
  font-weight: 500;
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  padding: 14px 20px;
  border-bottom: 1px solid #f3f4f6;
  border-right: none;
}

/* Rows */
:deep(.p-datatable .p-datatable-tbody > tr) {
  background: #ffffff;
  transition: background 0.15s;
}

:deep(.p-datatable .p-datatable-tbody > tr:hover) {
  background: #f9fafb;
}

:deep(.p-datatable .p-datatable-tbody > tr > td) {
  padding: 18px 20px;
  border-bottom: 1px solid #f3f4f6;
  border-right: none;
  color: #111827;
  font-size: 14px;
}

/* Nom en gras */
:deep(.p-datatable .p-datatable-tbody > tr > td:nth-child(2)) {
  font-weight: 600;
}

/* Suppression du style de sélection par défaut */
:deep(.p-datatable .p-datatable-tbody > tr.p-highlight) {
  background: #f0f9ff;
}


/* Paginator */
:deep(.p-paginator) {
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-top: none;
  border-radius: 0 0 12px 12px;
  padding: 10px 16px;
}

:deep(.p-paginator .p-paginator-page.p-highlight) {
  background: #3b82f6;
  color: #ffffff;
  border-radius: 8px;
  border-color: #3b82f6;
}

:deep(.p-paginator .p-paginator-page),
:deep(.p-paginator .p-paginator-prev),
:deep(.p-paginator .p-paginator-next),
:deep(.p-paginator .p-paginator-first),
:deep(.p-paginator .p-paginator-last) {
  color: #6b7280;
  border: none;
  min-width: 32px;
  height: 32px;
  border-radius: 8px;
}

:deep(.p-paginator .p-paginator-page:hover:not(.p-highlight)),
:deep(.p-paginator .p-paginator-prev:hover),
:deep(.p-paginator .p-paginator-next:hover) {
  background: #f3f4f6;
}


</style>
